export default "__VITE_ASSET__TW8_b$uO__"